<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Status Pembayaran'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'payment-statuses'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/payment-statuses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Status Pembayaran", route: "" },
      { title: "Daftar Status Pembayaran", route: "/masters/payment-statuses/list" },
      { title: "Tambah" },
    ])
  },

}

</script>